import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
export const DownloadLink = (params) => {
    return (_jsx(Link, { href: params.href, download: true, component: "a", children: _jsx(DownloadIcon, {}) }));
};
